/* unplugin-vue-components disabled */import { render } from "./baselayout.vue?vue&type=template&id=4c99e9e6"
import script from "./baselayout.vue?vue&type=script&lang=js"
export * from "./baselayout.vue?vue&type=script&lang=js"

import "./baselayout.vue?vue&type=style&index=0&id=4c99e9e6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/disney-leqi-back-ui-aliyun-qa/lqdsn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__